export * from './obrigatorio.decorator';
